import React, { useState } from 'react';
import PropTypes from 'prop-types';

import fullAddress from '../../utils/fullAddress';

function Preview (props) {
  const { data } = props;
  const defaultMsg = 'Copiar Dados Delivery';
  const copiedMsg = 'Dados Copiados';
  const [contentButton, setContentButton] = useState({
    msg: defaultMsg,
    disabled: false
  });

  const fullGender = type => {
    switch (type) {
      case 'F':
        return 'Feminino';
      case 'M':
        return 'Masculino';
      case 'N':
        return 'Neutro';
      case 'NR':
        return 'Não Cadastrado';
      default:
        return '---';
    }
  };

  const handleClickCopyData = () => {
    try {
      setContentButton({
        ...contentButton,
        msg: copiedMsg,
        disabled: true
      });
      setTimeout(() => {
        const url =
          'https://www.google.com.br/maps/place/' +
          fullAddress(data.address).replace(/ /g, '+');

        const content = `Nome: ${data.socialName}\n\nTelefone: ${
          data.phones.main
        }\n\nEndereço: ${fullAddress(data.address)}\n\nComplemento: ${
          data.address.complement
        }\n\nValor: R$ 0,00\n\nMaps: ${url}`;

        const textArea = document.createElement('textarea');
        textArea.value = content;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setContentButton({
          ...contentButton,
          msg: defaultMsg,
          disabled: false
        });
      }, 1400);
    } catch (err) {
      console.error('Error: ', err);
    }
  };

  return (
    <div className="container-fluid">
      <div className="alert alert-info mb-1" role="alert">
        Pré-visualização cliente&nbsp;
        <h4 className="d-inline">
          <span className="badge badge-secondary">{data.socialName}</span>
          <button
            type="button"
            className="btn btn-sm btn-primary float-right"
            onClick={handleClickCopyData}
            disabled={contentButton.disabled}
          >
            {contentButton.msg}
          </button>
        </h4>
      </div>
      <div className="row">
        <div className="col">
          <div>
            <span className="font-weight-bold">{`${
              parseInt(data.type) === 1 ? 'Nome Completo' : 'Razão Social'
            }`}</span>
            <p>{data.name}</p>
          </div>
        </div>
        <div className="col">
          <div>
            <span className="font-weight-bold">{`${
              parseInt(data.type) === 1 ? 'Nome Social' : 'Nome Fantasia'
            }`}</span>
            <p>{data.socialName}</p>
          </div>
        </div>
        <div className="col">
          <div>
            <span className="font-weight-bold">Tipo</span>
            <p>{`${parseInt(data.type) === 1 ? 'Física' : 'Jurídica'}`}</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div>
            <span className="font-weight-bold">Telefone Principal</span>
            <p>{data.phones.main}</p>
          </div>
        </div>
        <div className="col">
          <div>
            <span className="font-weight-bold">Telefone Recado</span>
            <p>{data.phones.message || '---'}</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div>
            <span className="font-weight-bold">Endereço</span>
            <p>{fullAddress(data.address)}</p>
          </div>
        </div>
        <div className="col-sm-4">
          <div>
            <span className="font-weight-bold">Complemento</span>
            <p>{data.address.complement || '---'}</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div>
            <span className="font-weight-bold">
              Data de{' '}
              {`${parseInt(data.type) === 1 ? 'Nascimento' : 'Fundação'}`}
            </span>
            <p>{`${new Date(data.born).toLocaleDateString()}`}</p>
          </div>
        </div>
        <div className="col">
          <div>
            <span className="font-weight-bold">E-mail</span>
            <p>{data.email || '---'}</p>
          </div>
        </div>
        {parseInt(data.type) === 1 && (
          <div className="col">
            <div>
              <span className="font-weight-bold">Gênero</span>
              <p>{`${fullGender(data.gender)}`}</p>
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col">
          {parseInt(data.type) === 1 ? (
            <div>
              <span className="font-weight-bold">CPF</span>
              <p>{data.cpf}</p>
            </div>
          ) : (
            <div>
              <span className="font-weight-bold">CNPJ</span>
              <p>{data.cnpj}</p>
            </div>
          )}
        </div>
        <div className="col">
          {parseInt(data.type) === 1 ? (
            <div>
              <span className="font-weight-bold">RG</span>
              <p>{data.rg || '---'}</p>
            </div>
          ) : (
            <div>
              <span className="font-weight-bold">IE</span>
              <p>{data.ie || '---'}</p>
            </div>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div>
            <span className="font-weight-bold">Facebook</span>
            <p>{data.facebook || '---'}</p>
          </div>
        </div>
        <div className="col">
          <div>
            <span className="font-weight-bold">Instagram</span>
            <p>{data.instagram || '---'}</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div>
            <span className="font-weight-bold">Informações Adicionais</span>
            <p>{data.additionalInformation || '---'}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

Preview.propTypes = {
  data: PropTypes.object
};

export default Preview;
